<template>
  <div>
    <bim-input v-model="filter" placeholder="Поиск по регионам" class="mb-6"/>
    <tree
      class="regions-list tree--small"
      :filter="filter"
      :data="parseRegionsArray"
      :options="treeOptions"
      ref="tree"
    >
    </tree>
  </div>
</template>

<script>
// https://amsik.github.io/liquor-tree/
import LiquorTree from 'liquor-tree'
import regionsJson from '../mixins/regions.js'

import bimInput from '@bimlib/components/bimInput'
import bimCheckbox from '@bimlib/components/bimCheckbox'

export default {
  name: 'Regions',
  components: { [LiquorTree.name]: LiquorTree, bimInput, bimCheckbox },
  props: {
    checked: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      filter: '',
      treeOptions: {
        filter: {
          emptyText: 'Извините, по вашему запросу ничего не найдено.',
        },
        multiple: true,
        checkbox: true,
        propertyNames: {
          id: 'id',
          text: 'name',
          children: 'regions',
        },
      },
      countries: regionsJson.countries,
      regions: regionsJson.regions,
    }
  },
  watch: {
    checked () {
      this.refreshCheckboxes()
    },
  },
  mounted () {
    this.$refs.tree.$on('node:checked', this.initEventViewer)
    this.$refs.tree.$on('node:unchecked', this.initEventViewer)

    if (this.checked.length)
      this.$refs.tree.$on('tree:mounted', () => {
        this.refreshCheckboxes()
      })
  },
  computed: {
    parseRegionsArray () {
      this.regions = this.regions.map(el => {
        const { name, id, ...other } = el
        return { name, id, data: { ...other } }
      })
      //   .sort((a, b) => {
      //   return a.id - b.id
      // })

      this.countries = this.countries.map(el => {
        const { name, id, ...other } = el
        return { name, id, data: { ...other } }
      })

      return this.countries.map(el => {
        el.regions = this.regions.filter(reg => reg.data.parent_id === el.id)
        return el
      })
    },
  },
  methods: {
    initEventViewer () {
      const selection = this.$refs.tree.findAll({ state: { checked: true } })

      const parseSelection = selection.map(el => ({ id: el.id, ...el.data }))
      // console.log(parseSelection)
      this.$emit('input', parseSelection)
    },
    refreshCheckboxes () {
      this.checked.forEach(el => {
        const findedNodes = this.$refs.tree.findAll({ id: el.toString() })
        findedNodes.check()
      })
    },
  },
}
</script>
